module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-02.907d0c32.svg";